import React from 'react';
import {
  PRIORITIES, PRIORITY_LABELS, TASK_TYPES, CLINICAL_DOMAINS, ASSIGNABLE_ROLES, OWNER_ROLE_LABELS,
} from './constants';

const selectStyle = {
  padding: '4px 8px', borderRadius: 6,
  border: '1px solid var(--wi-divider)',
  background: 'var(--wi-background-secondary)',
  color: 'var(--wi-text-primary)', fontSize: 13,
  cursor: 'pointer', fontFamily: 'var(--wi-font-family)', outline: 'none',
  width: '100%',
};

const inputStyle = { ...selectStyle, cursor: 'text' };

// Field set shared by the roster CreateTaskDrawer and the patient-file
// CreateTaskModal. The patient selector + care-period resolution stay in the
// container (they differ between the two surfaces).
export default function TaskForm({ draft, onChange }) {
  return (
    <>
      {/* Title */}
      <div>
        <p className="eyebrow text-secondary" style={{ margin: '0 0 8px' }}>Title</p>
        <input
          style={inputStyle}
          value={draft.title}
          onChange={(e) => onChange('title', e.target.value)}
          placeholder="Task title…"
        />
      </div>

      {/* Description */}
      <div>
        <p className="eyebrow text-secondary" style={{ margin: '0 0 8px' }}>Description</p>
        <textarea
          className="call-notes-input"
          rows={3}
          placeholder="Optional details…"
          value={draft.description}
          onChange={(e) => onChange('description', e.target.value)}
          style={{ width: '100%', resize: 'vertical', minHeight: 72 }}
        />
      </div>

      {/* Details grid */}
      <div>
        <p className="eyebrow text-secondary" style={{ margin: '0 0 10px' }}>Details</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="detail1 text-secondary">Priority</span>
            <select style={{ ...selectStyle, width: 'auto' }} value={draft.priority} onChange={(e) => onChange('priority', e.target.value)}>
              {PRIORITIES.map((p) => (
                <option key={p} value={p}>{PRIORITY_LABELS[p] || p}</option>
              ))}
            </select>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="detail1 text-secondary">Assigned to</span>
            <select style={{ ...selectStyle, width: 'auto' }} value={draft.owner_role} onChange={(e) => onChange('owner_role', e.target.value)}>
              {ASSIGNABLE_ROLES.map((r) => (
                <option key={r} value={r}>{OWNER_ROLE_LABELS[r] || r}</option>
              ))}
            </select>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="detail1 text-secondary">Domain</span>
            <select style={{ ...selectStyle, width: 'auto' }} value={draft.clinical_domain} onChange={(e) => onChange('clinical_domain', e.target.value)}>
              <option value="">None</option>
              {CLINICAL_DOMAINS.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="detail1 text-secondary">Task type</span>
            <select style={{ ...selectStyle, width: 'auto' }} value={draft.task_type} onChange={(e) => onChange('task_type', e.target.value)}>
              {TASK_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="detail1 text-secondary">Due date</span>
            <input
              type="date"
              style={{ ...selectStyle, width: 'auto' }}
              value={draft.due_at}
              onChange={(e) => onChange('due_at', e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
}
